import $, { ajax } from 'jquery';
import Tips from './Tips';
/* ===============================================================
Form contacts class
=============================================================== */
class Newsletter {
    // Initialize
    constructor() {
        this.buttonSubmit = $(
            '.irantheme-communication-newsletter-form-submit'
        );
        // Get admin url ajax from demo
        this.ajax_url = iranthemeWpData.adminAjax;
        this.tip = new Tips();
        this.events();
    }

    // Events
    events() {
        this.buttonSubmit.on('click', (e) => {
            e.preventDefault();
            // Get require values
            let ajax_url = this.ajax_url;
            let button = $(e.target);
            // Is element tag (i)
            if ($(e.target).prop('tagName') != 'BUTTON') {
                // Assign correct element
                button = $(button).parent();
            }
            let mail = $(button)
                .parents('.irantheme-communication-newsletter-form')
                .find('.irantheme-communication-newsletter-form-email')
                .val();
            // Send mail
            this.sendMail(ajax_url, mail);
        });
    }

    // Send mail ajax
    sendMail(ajax_url, mail) {
        $.ajax({
            beforeSend: (xhr) => {},
            url: ajax_url,
            type: 'POST',
            data: {
                action: 'newsletter_get_mail',
                new_mail: mail,
            },
            dataType: 'html',
            success: (response) => {
                if (response == 'wrong') {
                    this.tip.createTip(
                        'error',
                        'ایمیل ذخیره نشده! ایمیل صحیح نمی باشد.'
                    );
                } else if (response == 'repeat') {
                    this.tip.createTip(
                        'warning',
                        'ایمیل ذخیره نشده! ایمیل شما تکراری می باشد.'
                    );
                } else {
                    this.tip.createTip(
                        'success',
                        'ایمیل شما با موفقیت ذخیره شد.'
                    );
                }
            },
            error: (response) => {
                console.log(response.responseText);
            },
        });
    }
}

export default Newsletter;
